const success = {
  registered: 'Je bent succesvol geregistreerd.',
  changes_saved: 'Wijzigingen opgeslagen',
  email_sent: 'E-mail succesvol verzonden',
  invoice_created: 'Factuur aangemaakt',
  quotation_created: 'Offerte aangemaakt',
  logo_deleted: 'Logo succesvol verwijderd',
  bank_found: 'Bank gevonden: {{bankName}}',
  downloading: 'Worden gedownload...',
  invoices_downloading: 'Facturen worden gedownload...',
  quotations_downloading: 'Offertes worden gedownload...',
  status_updated: 'Status bijgewerkt',
  verification_email_resent: 'Verificatie-e-mail opnieuw verzonden. Controleer je inbox.',
  invoices_deleted: '{{count}} conceptfactuur verwijderd',
  invoices_deleted_plural: '{{count}} conceptfacturen verwijderd',
}

export default success
